/* eslint-disable no-console */
import axios from "axios";
import { NEW_LOGOUT_URL } from "../constants/AuthConstant";
import { MAX_FILE_TITLE_LEN } from "../constants/CommonConstants";
import {
  getContentUrlPath,
  getRestApiCall,
  getSelectedBrandName,
  getSelectedSite,
  getSubDomain,
  postRestApiCall,
} from "./helperFns";

export const hasOwnProp = (obj: object, key: string): boolean => {
  return Object.prototype.hasOwnProperty.call(obj, key);
};

export const getStyleString = (styles: any) =>
  Object.entries(styles)
    .map(([prop, value]) => `${prop}: ${value}`)
    .join("; ");

/**
 * courseId based get course fill details
 * post call
 */
export const getCourseDetailsApiCall = (courseId: string, secondaryArgs: any) => {
  const { prelemBaseEndpoint: { deliveryEndPointGq = "", language = "en" } = {}, sitename } =
    secondaryArgs;
  return getRestApiCall(
    `${deliveryEndPointGq}api/v1/web/en/delivery/course-model?path=${courseId}`,
    language,
    sitename,
  );
};

/**
 * courseId based get course fill details
 * post call
 */
export const getLearningListApiCall = (ele: any) => {
  const { secondaryArgs = {}, userId = "" } = ele;
  const { prelemBaseEndpoint: { deliveryEndPointGq = "", language = "en" } = {}, sitename } =
    secondaryArgs;

  const data = JSON.stringify({
    query: `query{publish_getuserCourses(user_id:${JSON.stringify(userId)})}`,
    variables: {},
  });

  return postRestApiCall(`${deliveryEndPointGq}user-service/`, data, language, sitename);
};
export const fetchOfferName = (VisitorID, publishRpiKey, secondaryArgs) => {
  const rpiClinetId = "aa07a6db-0e70-4aca-93cc-45056347ed04"; //"aa07a6db-0e70-4aca-93cc-45056347ed04"
  const rpiApiUrl = secondaryArgs?.rpiApiUrl; //"https://rpi-server-1.hcl-x.com"
  const apiUrl = `${rpiApiUrl}/interactionrealtimeapi/api/SmartAssets/${rpiClinetId}/Results`;
  const headers = {
    accept: "application/json",
    "Content-Type": "application/json",
  };
  const requestData = {
    Identity: {
      VisitorID: VisitorID,
    },
    AssetLookups: [
      {
        PublishID: publishRpiKey,
      },
    ],
  };

  // Send the POST request and return the Axios promise
  return axios
    .post(apiUrl, requestData, { headers })
    .then((response) => {
      localStorage.setItem(
        "OfferName",
        JSON.stringify({ data: response?.data?.Results[0]?.ResultContent }) || "",
      );
      return response.data; // Return the API response
    })
    .catch((error) => {
      console.error("Error fetching offer name:", error);
      return Promise.reject(new Error(error?.message || "Error fetching offer name")); // Return a rejected Promise with an Error
    });
};

/**
 * Fetches eCommerce products based on provided query parameters.
 * This function is used to handle common API requests for fetching eCommerce products.
@@ -153,17 +113,17 @@ export const getDynamicContentListApiCall = async (ele: any): Promise<any[]> =>
    const VisitorID = localStorageData || null;

    // If publishRpiKey and VisitorID exist, fetch the offer name and update cdpfilter
    if (publishRpiKey && VisitorID) {
      try {
        const response = await fetchOfferName(VisitorID, publishRpiKey, secondaryArgs);
        const offerName = response?.Results[0]?.ResultContent;
        if (offerName && Array.isArray(offerName)) {
          cdpfilter = offerName;
        }
      } catch (error) {
        console.error("Error fetching offer name:", error);
      }
    }
/**
 * Fetches eCommerce products based on provided query parameters.
 * This function is used to handle common API requests for fetching eCommerce products.
 *
 * @param {string} deliveryEndPointGq - The endpoint URL for making the API call.
 * @param {string} sitename - The name of the site to include in the request headers.
 * @param {object} queryParams - The query parameters to be sent in the API request.
 * @returns {Promise<Array>} - A promise that resolves to an array of fetched eCommerce products.
 */
export const fetchEcomProductsHandler = async (
  deliveryEndPointGq: string,
  sitename: string,
  queryParams: any,
): Promise<any[]> => {
  try {
    const response = await axios.post(
      deliveryEndPointGq,
      {
        query: `query fetchEcomProducts($pagePath: String!) {
          publish_fetchEcomProducts(queryParam: $pagePath)
        }`,
        variables: {
          pagePath: queryParams,
        },
      },
      {
        headers: {
          sitehost: sitename,
          "Content-Type": "application/json",
        },
      },
    );

    const { data: { data: { publish_fetchEcomProducts = [] } = {} } = {} } = response;
    return publish_fetchEcomProducts;
  } catch (error) {
    console.error("Error occurred in fetchEcomProductsHandler:", error);
    throw error; // Propagate the error to the caller
  }
};

/**
 * Fetches the dynamic content list using the provided parameters.
 *
 * @param {object} ele - An object containing parameters for the API call.
 * @returns {Promise<Array>} - A promise that resolves to an array of dynamic content.
 */
export const getDynamicContentListApiCall = async (ele: any): Promise<any[]> => {
  try {
    // Destructure and initialize parameters from the input element
    const { secondaryArgs = {}, start, numberOfRows, params, publishRpiKey } = ele;
    const { prelemBaseEndpoint: { deliveryEndPointGq = "" } = {}, sitename } = secondaryArgs;

    // Initialize cdpfilter as an empty array
    let cdpfilter: string[] = [];
    // Retrieve VisitorID from local storage
    const localStorageData = localStorage.getItem("VisitorID");
    const VisitorID = localStorageData || null;

    // If publishRpiKey and VisitorID exist, fetch the offer name and update cdpfilter
    if (publishRpiKey && VisitorID) {
      try {
        const response = await fetchOfferName(VisitorID, publishRpiKey, secondaryArgs);
        const offerName = response?.Results[0]?.ResultContent;
        if (offerName && Array.isArray(offerName)) {
          cdpfilter = offerName;
        }
      } catch (error) {
        console.error("Error fetching offer name:", error);
      }
    }

    // Destructure and initialize additional parameters from params
    const { tags = [], filter = "ALL", searchTerm = "", cdpFilterParent = null } = params;
    if (cdpFilterParent) cdpfilter = [...cdpfilter, ...cdpFilterParent];

    // Construct the query parameter object manually for the API call
    const queryParams = `{pagination:{start:${start},rows:${numberOfRows}},searchTerm:"${searchTerm}",tags:${JSON.stringify(tags)},cdpFilter:${JSON.stringify(cdpfilter)},filter:"${filter}",isSuggestive:false}`;

    // Make the API call to fetch eCommerce products
    return await fetchEcomProductsHandler(deliveryEndPointGq, sitename, queryParams);
  } catch (error) {
    console.error("Error occurred in getDynamicContentListApiCall:", error);
    throw error; // Propagate the error to the caller
  }
};

/**
 * Fetches the My Story content list using the provided parameters.
 *
 * @param {object} ele - An object containing parameters for the API call.
 * @returns {Promise<Array>} - A promise that resolves to an array of My Story content.
 */
export const getMyStoryContentListApiCall = async (ele: any): Promise<any[]> => {
  try {
    // Destructure the input parameters
    const { secondaryArgs = {}, start, numberOfRows } = ele;
    const { prelemBaseEndpoint: { deliveryEndPointGq = "" } = {}, sitename } = secondaryArgs;

    // Fetch user-selected tags and content types from local storage
    const localStorageData = localStorage.getItem("UserSelectedTags");
    const cdpfilter = localStorageData ? JSON.parse(localStorageData) : [];

    const localStorageTagData = localStorage.getItem("SelectedContentType");
    const tags = localStorageTagData ? JSON.parse(localStorageTagData) : [];

    // Ensure that the fetched data is in the expected format (array)
    const sanitizedCdpFilter = Array.isArray(cdpfilter) ? cdpfilter : [];
    const sanitizedTags = Array.isArray(tags) ? tags : [];

    // Set default values for filter and search term
    const filter = "ALL";
    const searchTerm = "";

    // Construct the query parameters for the API call
    const queryParams = `{pagination:{start:${start},rows:${numberOfRows}},searchTerm:"${searchTerm}",tags:${JSON.stringify(sanitizedTags)},cdpFilter:${JSON.stringify(sanitizedCdpFilter)},filter:"${filter}",isSuggestive:false}`;

    // Make the API call using the common handler function
    return await fetchEcomProductsHandler(deliveryEndPointGq, sitename, queryParams);
  } catch (error) {
    // Log any errors that occur and rethrow them for further handling
    console.error("Error occurred in getMyStoryContentListApiCall:", error);
    throw error;
  }
};

/**
 * user details update api call
 */
export const updateUserFormDetailsService = (ele: any) => {
  const { secondaryArgs = {}, userDetails = {} } = ele;
  const { prelemBaseEndpoint: { deliveryEndPointGq = "", language = "en", site_host = "" } = {} } =
    secondaryArgs;
  const data = {
    input: {
      email: userDetails.emailAddress,
      first_name: userDetails.firstName,
      last_name: userDetails.lastName,
      phone: userDetails.phoneNumber,
      company_name: userDetails.companyName,
      country: userDetails.country,
      message: userDetails.message,
    },
  };
  return postRestApiCall(`${deliveryEndPointGq}/contact_us/save`, data, language, site_host);
};

export const getFirstTwoletters = (title: string) => {
  if (!title) return "";
  const words = title.trim().split(" ");
  if (words.length === 1) return words[0].substring(0, 2);
  return words[0].charAt(0) + words[words.length - 1].charAt(0);
};

export const openPageInNewTab = (url: string) => {
  if (window && url) {
    const infoUrl = window?.open(url, "_blank");
    if (infoUrl) {
      infoUrl.focus();
    }
  }
};

export const formatTitle = (title: string) => {
  return title.replace(/[^a-zA-Z0-9-_ ]|[_-](?=[_-])/g, "");
};

export const frameTitle = (title: string) => {
  if (!title) return "";
  let formattedTitle = title.trim();
  formattedTitle = formattedTitle.replace(/^(?:[-_\s]+)|(?:[-_\s]+)$/g, "");
  return formattedTitle;
};

export const formatPageUrl = (url) => {
  let tmp = url?.toLowerCase();
  tmp = tmp.replace(/[^a-zA-Z0-9_\-\s]/g, ""); // Allow only numbers, alphabets, underscore, hyphen, spaces
  tmp = tmp.replace(/(\s+)/g, "-"); // Replace spaces with hyphens
  tmp = tmp.replace(/([_-]+)/g, "-"); // Replace multiple underscores or hyphens with a single hyphen
  tmp = tmp.replace(/^(?:[-_]+)|(?:[-_]+)$/g, ""); // Remove hyphens or underscores at the beginning or end
  return tmp;
};

/**
 * Brand-aware canonical path (no host) for a content item from its slug, e.g.
 * `/brand-name/article/my-slug`. This relative form is what gets stored in the backend.
 * Falls back to `language` (e.g. the current i18n language) when no brand is selected —
 * multi-brand support isn't enabled for every site. `tagName` defaults to "sitepage",
 * matching getContentUrlPath's own default content type. `brandName` overrides the active
 * dropdown brand — Share With Brands passes the document's primary brand so shared docs
 * keep one canonical (KIWI-6401).
 */
export const getCanonicalPagePath = (
  slug: string,
  language: string,
  tagName = "sitepage",
  brandName = "",
): string =>
  slug
    ? `/${formatPageUrl(brandName || getSelectedBrandName() || language)}${getContentUrlPath({ tagName, slug })}`
    : "";

/**
 * TODO: not a generic solution — this is specific to ETG (single brand-or-language
 * segment). To be enhanced later to make it generic.
 *
 * Absolute canonical URL shown to the user, e.g.
 * `https://sub.domain.com/brand-name/article/my-slug`. Authoring displays this but
 * stores the relative getCanonicalPagePath value.
 */
export const getCanonicalPageUrl = (
  slug: string,
  language: string,
  tagName = "sitepage",
  brandName = "",
): string =>
  slug ? `${getSubDomain()}${getCanonicalPagePath(slug, language, tagName, brandName)}` : "";

/** Turns a stored relative path into an absolute URL for display; absolute values pass through. */
export const toAbsoluteUrl = (url = ""): string =>
  url.startsWith("/") ? `${getSubDomain()}${url}` : url;

export const formatAddPrelem = (item) => {
  return {
    PrelemId: item.PrelemId, // Unique Name
    PrelemName: item.PrelemName,
    SeoEnabled: item.SeoEnabled,
    AnalyticsEnabled: item.AnalyticsEnabled,
    InstanceId: "pr_cont1",
    DocumentPath: item.DocumentPath,
    DocumentCreationPath: item.DocumentCreationPath,
    DocumentType: item.DocumentType,
    IsHidden: false,
    IsModified: false,
    StructuredData: "",
    //RpiKey: item?.RpiKey,
  };
};

export const handleLogout = () => {
  localStorage.clear();
  sessionStorage.clear();
  sessionStorage.setItem("isLoggingOut", "true");
  window.location.href = NEW_LOGOUT_URL;
};

export const getRequestFromDelivery = async (url) => {
  try {
    const res = await axios.get(process.env.NX_PUBLIC_PUBLISH_API_URL_GENERIC + url, {
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        sitename: getSelectedSite(),
        sitehost: getSubDomain(),
      },
      withCredentials: true,
    });
    return res?.data?.result ? res?.data?.result : res?.data;
  } catch (err: any) {
    if (err?.response?.data?.code === 401 && !url.includes("verify")) {
      handleLogout();
    }
    return err;
  }
};
export const navigateToContent = (navigate, navigateUrl, contentType, pageName) => {
  navigate(navigateUrl, {
    state: { contentType, pageName },
  });
};

// function to limit the uploaded file title length
export const trimFileTitle = (str) => {
  return str.slice(0, MAX_FILE_TITLE_LEN);
};

interface MetaFields {
  AltText: string;
  Name: string;
  Title: string;
  Description: string;
  Attribution: boolean;
}

interface OriginalImage {
  original_image_relative_path: string;
  visibility: string;
  ext: string;
  bitStreamId: string;
  auto: boolean;
  MetaFields: MetaFields;
}

interface PublishedImage {
  aspect_ratio: string;
  folder_path: string;
}

export const generateImageObjects = (imageUrl: string) => {
  // Remove leading slash if present
  const cleanUrl = imageUrl.startsWith("/") ? imageUrl.slice(1) : imageUrl;

  // Find the last dot to separate the extension
  const lastDotIndex = cleanUrl.lastIndexOf(".");

  // Extract filename without the extension
  const fileName = cleanUrl.substring(0, lastDotIndex);

  // Extract the extension (without the dot)
  const ext = cleanUrl.substring(lastDotIndex + 1);
  // Create the original_image object
  const original_image: OriginalImage = {
    original_image_relative_path: fileName, // Just use the filename without extension
    visibility: "public",
    ext: ext,
    bitStreamId: "",
    auto: true,
    MetaFields: {
      AltText: fileName,
      Name: fileName,
      Title: fileName,
      Description: `This is for ${fileName}`,
      Attribution: false,
    },
  };

  // Create the published_images array for different aspect ratios
  const aspectRatios = ["landscape", "square", "portrait", "hero", "card1", "card2"];
  const published_images: PublishedImage[] = aspectRatios.map((ratio) => ({
    aspect_ratio: ratio,
    folder_path: `${fileName}-${ratio}`, // No bucket path, just filename and ratio
  }));

  return { original_image, published_images };
};

export const getDisplayContentType = (ct) => {
  switch (ct?.toLowerCase()) {
    case "article":
      return "Article";
    case "quiz":
      return "Quiz";
    case "poll":
      return "Poll";
    case "event":
      return "Event";
    case "formbuilder":
      return "Form";
    case "imagegallery":
      return "Image Gallery";
    case "videogallery":
      return "Video Gallery";
    case "gallery":
      return "Gallery";
    case "vod":
      return "VOD";
    case "profile":
      return "Profile";
    case "faqs":
      return "FAQ";
    case "wheel":
      return "Wheel";
    case "servicecard":
      return "Service Card";
    case "appevent":
      return "App Event";
    case "playeranalysis":
      return "Player Analysis";
    case "speaker":
      return "Speaker";
    default:
      return ct;
  }
};

export const menuDisplayOrder = [
  "dashboard",
  "page",
  "content",
  "collection",
  "gamification",
  "TournamentSetting",
  "reports",
  "Community",
  "UserManagement",
  "Workflow",
  "Menu",
  "AssetsManager",
  "SiteSetting",
  "Site",
  "MobileSetting",
];

export const frameDocumentType = (schemaType) => {
  const collectionTypes = ["collection", "tournamentsetting", "mobilesetting", "menu"];
  //Node has only content and collection document types in backend.
  //So we have to either send contentType || collection as document type when fetching or updating data.
  //This property is mostly used for API payloads.
  // return schemaType === "content" || schemaType !== "collection" ? "contentType" : schemaType;
  return schemaType === "content"
    ? "contentType"
    : collectionTypes.includes(schemaType.toLowerCase())
      ? "collection"
      : schemaType;
};
export const yearOptions = () => {
  const currentYear = new Date().getFullYear();
  const years: Array<{ name: string; value: string }> = [];
  for (let year = currentYear; year >= 1900; year -= 1) {
    years.push({ name: String(year), value: String(year) });
  }
  return years;
};
// Extract year from ISO string to avoid timezone shifts when showing DOB year.
export const getDobYearValue = (dobValue: any) => {
  if (!dobValue) return "";
  const value = String(dobValue).trim();
  // handle ISO string like 2025-12-31T18:30:00.000Z is coming
  if (value?.includes("T")) {
    const [yearPart] = value?.split("-");
    return yearPart || "";
  }
  const parsed = new Date(value);
  if (!Number.isNaN(parsed.getTime())) {
    return String(parsed.getUTCFullYear());
  }
  return "";
};
export const safeParse = (value: any) => {
  try {
    if (typeof value === "string") {
      const first = JSON.parse(value);
      if (typeof first === "string") {
        try {
          return JSON.parse(first) || {};
        } catch {
          return first || {};
        }
      }
      return first || {};
    }
    return value || {};
  } catch {
    return {};
  }
};
